export default {
  export: '数据下载',
  export_condition: '按条件导出',
  export_sku: '按商品导出',
  export_history: '下载历史',
};
